import { render, staticRenderFns } from "./category-main.vue?vue&type=template&id=384fd176&scoped=true"
import script from "./category-main.vue?vue&type=script&lang=js"
export * from "./category-main.vue?vue&type=script&lang=js"
import style0 from "./category-main.vue?vue&type=style&index=0&id=384fd176&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384fd176",
  null
  
)

export default component.exports